<template>
    <div :class="[
            'pp-form-item',
            `pp-form-item--${currentSize}`,
            {'is-error': isError, 'with-error': showError && isError},
        ]">
        <div class="pp-form-item__label" 
            :style="{width: currentLabelWidth}">
            <slot name="label">
                <span v-if="required" class="required">*</span>
                {{label}}
            </slot>
        </div>
        <div class="pp-form-item__content">
            <slot></slot>
            <transition name="pp-form-error">
                <span v-show="showError" class="pp-form-item__error">
                    {{currentError}}
                </span>
            </transition>
        </div>
        <div class="pp-form-item__suffix">
            <i v-show="isError" class="pp-icon-warning" @click="showErrorMsg"></i>
        </div>
    </div>
</template>

<script>
import EventBus from '../../../src/util/event-bus.js'
import Validate from '../../../src/util/validate.js'

/**
 * 表单项
 * @param {String} label 表单项名称
 * @param {String} prop 表单项对应字段名
 * @param {String} size 尺寸
 * @param {String} error 错误信息
 * @param {[Object, Array]} fields 校验项
 * @param {String} labelWidth 表单项名称宽度
 * @param {Boolean} required 显示必填*符
 */
export default {
    name: 'pp-form-item',
    inheritAttrs: false,
    provide: function() {
        return {
            'FormItem': this,
        };
    },
    inject: {
        Form: {
            default: '',
        }
    },
    props: {
        label: String,
        prop: String,
        size: {
            type: String,
            validator: function(value) {
                return ['normal', 'small', 'mini'].includes(value);
            },
        },
        error: String,
        fields: [Object, Array],
        labelWidth: String,
        required: Boolean,
    },
    data: function() {
        return {
            showError: false,
            errorMsg: '',
        };
    },
    computed: {
        currentSize: function() {
            return this.size || this.Form.size;
        },
        currentLabelWidth: function() {
            return this.labelWidth || this.Form.labelWidth;
        },
        isError: function() {
            return !!this.currentError;
        },
        currentFields: function() {
            return this.prop 
                ? this.Form.currentFields[this.prop] || this.fields || null
                : this.fields || null;
        },
        triggers: function() {
            return this.prop 
                ? EventBus.trigger(this.currentFields, this.prop)
                : [];
        },
        currentError: function() {
            return this.error || this.errorMsg;
        },
    },
    watch: {
        'Form.errorMsg': {
            deep: true,
            handler: function(n, o) {
                this.errorMsg = n[this.prop] || ''
            },
        },
    },
    created: function() {
        this.insertFields()
    },
    methods: {
        insertFields: function() {
            if(!this.Form || !this.fields) return;

            let fields = this.Form.currentFields[this.prop];

            if(fields) {
                this.Form.currentFields[this.prop] = Array.isArray(this.fields)
                    ? [fields, ...this.fields]
                    : [fields, this.fields]
            }
            else {
                this.Form.currentFields[this.prop] = this.fields
            }
        },

        showErrorMsg: function() {
            this.showError = !this.showError
        },

        onTrigger: function(trigger, value) {
            this.errorMsg = Validate.validator(this.currentFields, value) 
        },
    },
}
</script>

<style>

</style>
